import { StateProvider, StateService } from "@uirouter/angularjs";
import {
  getProcessDetailState,
  getProcessState,
  nullSymbol,
} from "../../../Process/config";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "../../../Process/services/processInformationService";
import {
  ProcessGroup,
  ProcessInformation,
} from "../../../Process/model/ProcessGroups";
import { addRoute as addNotesRoutes } from "../../../Process/views/processDetail/notes/route";

const contractBaseState = "main.contract";
const machineBaseState = "main.machines";

desertDiamondContractProcessRouteConfig.$inject = ["$stateProvider"];
export function desertDiamondContractProcessRouteConfig(
  $stateProvider: StateProvider,
) {
  $stateProvider
    .state(
      `${contractBaseState}.process`,
      getProcessState(
        "contract",
        nullSymbol,
        [() => ({ Include: "ContractNumbers" })],
        onNewProcessSelected,
        additionalGridColumns,
      ),
    )
    .state(
      `${contractBaseState}.process.detail`,
      getProcessDetailState([
        ProcessInformationServiceName,
        "processGroup",
        (
          processInformationService: ProcessInformationService,
          processGroup: ProcessGroup,
        ) => processInformationService.getDetailTemplate(processGroup.Id),
      ]),
    );
  addNotesRoutes($stateProvider, `${contractBaseState}.process.detail.notes`);
}

desertDiamondMachineProcessRouteConfig.$inject = ["$stateProvider"];
export function desertDiamondMachineProcessRouteConfig(
  $stateProvider: StateProvider,
) {
  $stateProvider
    .state(
      `${machineBaseState}.process`,
      getProcessState(
        "machine",
        Symbol(`${machineBaseState}.process`),
        [() => ({})],
        onNewProcessSelected,
        additionalGridColumns,
      ),
    )
    .state(
      `${machineBaseState}.process.detail`,
      getProcessDetailState([
        ProcessInformationServiceName,
        "processGroup",
        (
          processInformationService: ProcessInformationService,
          processGroup: ProcessGroup,
        ) => processInformationService.getDetailTemplate(processGroup.Id),
      ]),
    );
  addNotesRoutes($stateProvider, `${machineBaseState}.process.detail.notes`);
}

additionalGridColumns.$inject = [ProcessInformationServiceName, "processGroup"];
function additionalGridColumns(
  processInformationService: ProcessInformationService,
  processGroup: ProcessGroup,
) {
  return processInformationService.getAdditionalGridColumns(processGroup) ?? [];
}

onNewProcessSelected.$inject = [
  ProcessInformationServiceName,
  "processGroup",
  "$state",
];
function onNewProcessSelected(
  processInformationService: ProcessInformationService,
  processGroup: ProcessGroup,
  $state: StateService,
) {
  return [
    "process",
    (process: ProcessInformation) =>
      processInformationService
        .createNewProcessFlow(processGroup, process)
        .then((processResponse) =>
          $state.go(".detail", {
            processInstancesId: processResponse.Id,
          }),
        ),
  ];
}
